export default class TimerFilter {
    public static transform(time: number): string {
        const second = 1000,
            minute = second * 60,
            hour = minute * 60,
            day = hour * 24;
        let hours = Math.floor((time % (day)) / (hour));
        let minutes = Math.floor((time % (hour)) / (minute));
        let seconds = Math.floor((time % (minute)) / second);
        const values: string[] = [];
        if (hours > 0) {
            values.push(TimerFilter.formattedTime(hours));
        }
        values.push(TimerFilter.formattedTime(minutes));
        values.push(TimerFilter.formattedTime(seconds));
        return values.join(':');
    }

    private static formattedTime(time: number): string {
        let formattedTime: string = time.toString();
        if (time < 10) {
            formattedTime = '0' + formattedTime;
        }
        return formattedTime;
    }
}
